import { HttpBaseApi } from "../common.interfaces";
import { localStorageGet } from "../../utils/localStorage";
import { IAuthParams, ILoggedInUser } from "./auth.interfaces";
import { mockLogin } from "../../__mocks__/login/loginUserMock";

const subBaseEndPoint = "/signin";
const refreshPath = "/refresh";

const isAppWithMockData = (): boolean =>
  import.meta.env.VITE_APP_WITH_MOCK_DATA === "true";

export const authoriseUserRequest = (
  httpAPI: HttpBaseApi,
  requestObj: IAuthParams,
): Promise<ILoggedInUser> => {
  if (isAppWithMockData()) {
    return mockLogin(requestObj);
  }
  return httpAPI.auth.post<ILoggedInUser>(`${subBaseEndPoint}`, requestObj);
};

export const refreshTokenRequest = async (
  httpAPI: HttpBaseApi,
): Promise<string> => {
  if (isAppWithMockData()) {
    const token = localStorageGet("token");
    if (token) {
      return token as string;
    }
    throw new Error("No token available to refresh");
  }

  const response = await httpAPI.auth.post<{
    token: string;
    jwtToken?: string;
  }>(`${refreshPath}`, {});

  return response.token || response.jwtToken || "";
};
